<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`公司利润表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :btns="btns" :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: "dwages",
      getListUrl: "company",
      breadcrumb: [{ name: "财务管理" }, { name: "公司利润表" }],
      formInline: { year: undefined },
      formCtrl: [
        {
          label: "年份：",
          placeholder: "请选择年份",
          keyName: "year",
          type: "year",
        },
      ],
      cols: [
        { prop: "month", label: "月份" },
        { prop: "car_count", label: "车辆数量", minwidth: 120 },
        { prop: "allorder", label: "公司运费", minwidth: 120 },
        { prop: "infreight", label: "司机运费", minwidth: 120 },
        { prop: "groprofit", label: "公司利润", minwidth: 120 },
        { prop: "avg_profit", label: "单车平均利润", minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ month }) => {
            this.$router.push(`/finance/companyProfitFleet?month=${month}`);
          },
        },
      ],
      getTotalProperty: [
        "car_count",
        "allorder",
        "infreight",
        "groprofit",
        "avg_profit",
      ],
      baseParams: ["year"],
    };
  },
  methods: {
    getTotal(param) {
      const { columns, data } = param;
      // console.log(param)
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0 && column.type !== "selection") {
          sums[index] = "合计";
          return;
        }
        if (columns[0].type === "selection" && index === 1) {
          sums[index] = "合计";
          return;
        }
        // console.log({ ...column }, { ...data }, 1111);
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'avg_profit') {
          // const avg = values.reduce((a, b) => a + b, 0) / values.length;
          // sums[index] = avg.toFixed(2)
          const profits = data.map((item) => Number(item['groprofit']))
          const car_count = data.map((item) => Number(item['car_count']))
          let total_profits = 0
          let total_cars = 1
          if (profits && profits.length) {
            total_profits = profits.reduce((a, b) => Number(a) + Number(b), 0)
          }
          if (car_count && car_count.length) {
            total_cars = car_count.reduce((a, b) => Number(a) + Number(b), 0)
          }
          sums[index] = this.keep2(total_profits / total_cars)
        } else if (
          !values.every((value) => isNaN(value)) &&
          this.getTotalProperty.includes(column.property)
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (column.label == "车辆数量") {
              if (!isNaN(value)) {
                return Number(prev) + Number(curr);
              } else {
                return prev;
              }
            } else {
              if (!isNaN(value)) {
                return this.keep2(Number(prev) + Number(curr));
              } else {
                return this.keep2(prev);
              }
            }
          }, 0);
          // sums[index] += ' 元';
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  mounted() {
    // console.log({ ...this.formInline })
    this.getList();
  },
};
</script>
